import { render } from "./Landingpage.vue?vue&type=template&id=7431de71"
import script from "./Landingpage.vue?vue&type=script&lang=js"
export * from "./Landingpage.vue?vue&type=script&lang=js"
script.render = render

export default script